import { HiArrowSmLeft } from "react-icons/hi"
import axios from "axios";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { motion } from "framer-motion";
import {BsFillCheckCircleFill} from "react-icons/bs"
import { Link } from "react-router-dom";

export default function NotificationFront() {
    const session_id = Cookies.get("jwt");
    const [dataMessageInbox, setDataMessageInbox] = useState([])
    // const [heldMessage, setHeldMessage] = useState(null);
    const [waitSelectedMessage , setWaitSelectedMessage] = useState(null)
    const [selectedMessageID, setSelectedMessageID] = useState([])
    function parseTimestamp(timestamp) {
        return new Date(timestamp);
    }

    // Function to format the date into DD-MM-YYYY
    function formatDateToDDMMYYYY(date) {
        const day = ("0" + date.getUTCDate()).slice(-2);
        const month = ("0" + (date.getUTCMonth() + 1)).slice(-2);
        const year = date.getUTCFullYear();
        return `${day}-${month}-${year}`;
    }

    function getInBoxMessage() {
        axios.get(`${process.env.REACT_APP_API}/inbox/getInbox`, {
            headers: {
                Authorization: `Bearer ${session_id}`
            }
        }).then((res) => {
            const message = res.data.Inbox
            console.log(res.data)
            setDataMessageInbox(message)
        }).catch((err) => {
            console.log(err);
        })
    }


    useEffect(() => {
        getInBoxMessage()
    }, [])

    useEffect(()=>{
        if(session_id === undefined){
            window.location.replace('/login')
        }
    },[])

    function handleClearAllMessageInbox() {
        axios.post(`${process.env.REACT_APP_API}/inbox/deleteMessage`,{
            "messageIds" : selectedMessageID
        } ,{
            headers: {
                Authorization: `Bearer ${session_id}`
            }
        }).then((res) => {
            console.log(res.data)
            getInBoxMessage()

        }).catch((err) => {
            console.log(err);
        })
    }

    function handleRemoveInboxNotification(){
        setWaitSelectedMessage(!waitSelectedMessage)
        setSelectedMessageID([])
    }

    function handleSelectedInbox(id) {
        console.log(id);
    
        if (selectedMessageID.includes(id)) {
    
            const updatedSelectedMessages = selectedMessageID.filter(messageId => messageId !== id);
            setSelectedMessageID(updatedSelectedMessages);
        } else {

            setSelectedMessageID([...selectedMessageID, id]); 
        }
    }
    
    function handleSaveIDMessage(idMessage) {
        sessionStorage.setItem("messageID", idMessage)
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            {/* Header Section */}
            <div className="bg-black text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="text-center"
                    >
                        <h1 className="text-5xl md:text-6xl font-bold mb-4">การแจ้งเตือน</h1>
                        <p className="text-lg text-gray-300">
                            คุณมีการแจ้งเตือน{" "}
                            <span className="text-white font-semibold">{dataMessageInbox.length} รายการ</span>
                        </p>
                        <div className="mt-8 inline-flex items-center gap-2 text-sm text-gray-400">
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                            </svg>
                            <span>อัพเดทล่าสุด</span>
                        </div>
                    </motion.div>
                </div>
            </div>

            {/* Action Bar */}
            <div className="bg-white border-b border-gray-200 sticky top-0 z-10 shadow-sm">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    <div className="flex items-center justify-end gap-4">
                        {waitSelectedMessage && (
                            <button
                                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors font-medium"
                                onClick={handleClearAllMessageInbox}
                            >
                                ลบที่เลือก
                            </button>
                        )}
                        <button
                            className="px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors font-medium"
                            onClick={handleRemoveInboxNotification}
                        >
                            {waitSelectedMessage ? 'ยกเลิก' : 'แก้ไข'}
                        </button>
                    </div>
                </div>
            </div>

            {/* Notifications List */}
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">

            {dataMessageInbox.slice().reverse().map((data, index) => {
                const parsedDate = parseTimestamp(data.sent_date);
                const formattedDate = formatDateToDDMMYYYY(parsedDate);
                const readed = data.readed;
                

                const containerVariants = {
                    hidden: { opacity: 0 },
                    visible: { opacity: 1 },
                };

                const itemVariants = {
                    hidden: { opacity: 0, x: -20 },
                    visible: { opacity: 1, x: 0, transition: { type: "spring", duration: 1 } },
                };

                const itemTransition = {
                    delay: index * 0.2, // Delay each item by 0.2 seconds
                };

                return (
                    <motion.div
                        key={data.message_id}
                        className={`relative border-b border-gray-200 last:border-b-0 ${selectedMessageID.includes(data.message_id) ? 'bg-gray-50' : 'bg-white'} hover:bg-gray-50 transition-colors`}
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                        onClick={() => handleSelectedInbox(data.message_id)}
                    >
                        <Link to={waitSelectedMessage ? '' : `/noti/${data.message_id}`} onClick={() => handleSaveIDMessage(data.message_id)}>
                            <motion.div
                                className={`p-6 ${selectedMessageID.includes(data.message_id) ? 'pl-16' : ''}`}
                                variants={itemVariants}
                                transition={itemTransition}
                            >
                                <div className="flex items-start justify-between gap-4">
                                    <div className="flex-1">
                                        <div className="flex items-center gap-3 mb-2">
                                            <h1 className="font-bold text-lg text-black">{data.title}</h1>
                                            {!readed && (
                                                <span className="flex-shrink-0 w-3 h-3 bg-red-500 rounded-full animate-pulse"></span>
                                            )}
                                        </div>
                                        <p className="text-gray-600 text-sm leading-relaxed">{data.description.slice(0, 100)}...</p>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <time className="text-xs text-gray-500 flex items-center gap-1">
                                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                                            </svg>
                                            {formattedDate}
                                        </time>
                                    </div>
                                </div>
                            </motion.div>
                        </Link>

                        {selectedMessageID.includes(data.message_id) && (
                            <div className="absolute top-1/2 left-6 -translate-y-1/2 text-2xl text-black">
                                <BsFillCheckCircleFill />
                            </div>
                        )}
                    </motion.div>
                );
            })}
                </div>
            </div>



        </div>
    )
}